import { render, staticRenderFns } from "./LoginRegisterPage.vue?vue&type=template&id=54f3bed2&scoped=true&"
import script from "./LoginRegisterPage.vue?vue&type=script&lang=js&"
export * from "./LoginRegisterPage.vue?vue&type=script&lang=js&"
import style0 from "./LoginRegisterPage.vue?vue&type=style&index=0&id=54f3bed2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f3bed2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VCard,VForm})
